import { Component, OnInit } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  template: '<p>Processing login...</p>'
})
export class LoginComponent implements OnInit {

  constructor(private _auth: AuthService, private _router: Router) { }

  ngOnInit() {
    console.log("Calling Login");
    this._auth.login();
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/auth/login.component.ts